import { Grid, Typography, Box } from "@mui/material";
import { GroupedDocumentList, PersonalDocumentCardItem } from "../../../types";
import { ReactComponent as DownloadIcon } from "../../../public/icons/DownloadIcon.svg";
import DocumentCard from "../../LibraryDocument/DocumentCardsList/DocumentCard";
import ReactSvgIcon from "../../UIElements/ReactSvgIcon";
import {
    _downloadCertificate,
    _downloadContract,
    extractDocumentPdfName,
} from "../../../helpers";
// import { downloadContract } from "../../../services";

type DocumentListProps = {
    groupedDocumentListByRefs: GroupedDocumentList;
};

export default function DocumentList({
    groupedDocumentListByRefs,
}: DocumentListProps) {
    return (
        <Grid container spacing={2}>
            {Object.values(groupedDocumentListByRefs).map(
                (
                    docuementListOfRef: PersonalDocumentCardItem[],
                    index: number
                ) => {
                    const { referenciel } = docuementListOfRef[0];
                    return (
                        <Grid item xs={12} md={6} key={index}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: "1rem",
                                    flexDirection: "column",
                                    flexShrink: 0,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#023",
                                        fontFamily: "Roboto",
                                        fontSize: "1.125rem",
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        lineHeight: "normal",
                                    }}
                                >
                                    {referenciel ? referenciel.name : ""}
                                </Typography>
                                {docuementListOfRef.map(
                                    (doc: PersonalDocumentCardItem) => {
                                        const {
                                            id,
                                            contractUrl,
                                            certificationUrl,
                                        } = doc;

                                        const renderDocumentCard = ({
                                            url,
                                            name,
                                            download,
                                        }: {
                                            url: string;
                                            name: string;
                                            download: Function;
                                        }) => {
                                            return (
                                                <DocumentCard
                                                    documentCardItem={{
                                                        id,
                                                        name,

                                                        actions: {
                                                            download: {
                                                                icon: (
                                                                    <ReactSvgIcon
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                        }}
                                                                        onClick={async () => {
                                                                            if (
                                                                                url
                                                                            ) {
                                                                                await download(
                                                                                    id,
                                                                                    `${name} pour ` +
                                                                                        (referenciel
                                                                                            ? referenciel.name
                                                                                            : "")
                                                                                );
                                                                            }
                                                                        }}
                                                                        ReactIcon={
                                                                            DownloadIcon
                                                                        }
                                                                        reactIconProps={{
                                                                            width: "1.5rem",
                                                                            height: "1.5rem",
                                                                        }}
                                                                    />
                                                                ),
                                                                do: () => {},
                                                            },
                                                        },
                                                    }}
                                                />
                                            );
                                        };

                                        return (
                                            <Box
                                                key={id}
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "flex-start",
                                                    gap: "1rem",
                                                    flexDirection: "column",
                                                    flexShrink: 0,
                                                    width: "100%",
                                                }}
                                            >
                                                {contractUrl
                                                    ? renderDocumentCard({
                                                          url:
                                                              contractUrl ?? "",
                                                          name: extractDocumentPdfName(
                                                              contractUrl ?? ""
                                                          ),
                                                          download:
                                                              _downloadContract,
                                                      })
                                                    : null}

                                                {certificationUrl
                                                    ? renderDocumentCard({
                                                          url:
                                                              certificationUrl ??
                                                              "",
                                                          name: extractDocumentPdfName(
                                                              certificationUrl ??
                                                                  ""
                                                          ),
                                                          download:
                                                              _downloadCertificate,
                                                      })
                                                    : null}
                                            </Box>
                                        );
                                    }
                                )}
                            </Box>
                        </Grid>
                    );
                }
            )}
        </Grid>
    );
}
